import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card shadow-none" }
const _hoisted_2 = { class: "card-header border-bottom border-bottom-dashed border-gray-600" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "d-flex align-items-center gap-2 gap-lg-3" }
const _hoisted_5 = { class: "btn btn-sm btn-light-primary fs-4 rounded-pill" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-menu-button-wide-fill fs-3" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-down" }, null, -1)
const _hoisted_8 = { class: "card-toolbar g-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-sm btn-light-danger text-nowrap"
}, " حذف بورد ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-sm btn-light-warning text-nowrap"
}, " ویرایش بورد ", -1)
const _hoisted_11 = { class: "required fs-7 fw-bold mb-2" }
const _hoisted_12 = { class: "d-flex align-items-end ms-2" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " ویرایش ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-sm btn-light text-nowrap"
}, " ایجاد بورد ", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-7 fw-bold mb-2" }, "نام بورد را وارد کنید", -1)
const _hoisted_19 = { class: "d-flex align-items-end ms-2" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " ذخیره ", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = { class: "card-body p-0" }
const _hoisted_25 = { class: "row d-flex flex-row flex-nowrap scroll-x" }
const _hoisted_26 = { class: "position-absolute top-50 end-100 svg-icon svg-icon-2tx svg-icon-gray-400 mb-5" }
const _hoisted_27 = { class: "fv-row mb-5" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center text-gray-600 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required fs-8" }, "عنوان")
], -1)
const _hoisted_29 = { class: "fv-row mb-5" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center text-gray-600 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required fs-8" }, "موقعیت")
], -1)
const _hoisted_31 = { class: "fv-row d-flex justify-content-around" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "btn btn-sm btn-outline bg-light-danger btn-outline-dashed btn-outline-danger" }
const _hoisted_34 = { class: "col min-w-150px mw-200px min-h-150px m-5 card card-body" }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-lg ms-1" }, null, -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" افزودن ")
const _hoisted_38 = [
  _hoisted_36,
  _hoisted_37
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_dropdown, null, {
            dropdown: _withCtx(() => [
              (_ctx.boardsList)
                ? (_openBlock(), _createBlock(_component_el_dropdown_menu, { key: 0 }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.boardsList, (board, i) => {
                        return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                          key: i,
                          onClick: ($event: any) => (_ctx.activeBoardId = board.id)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(board.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_5, [
                _hoisted_6,
                _createTextVNode(" مدیریت سر برگ‌های " + _toDisplayString(_ctx.activeBoardInfo?.title) + " ", 1),
                _hoisted_7
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_el_popconfirm, {
          "confirm-button-text": _ctx.translate('yes'),
          "cancel-button-text": _ctx.translate('cancel'),
          "icon-color": "#626AEF",
          title: _ctx.translate('Are you sure you want to delete this'),
          onConfirm: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteBoard(_ctx.activeBoardId)))
        }, {
          reference: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }, 8, ["confirm-button-text", "cancel-button-text", "title"]),
        _createVNode(_component_el_popover, {
          placement: "right",
          width: 300,
          trigger: "click"
        }, {
          reference: _withCtx(() => [
            _hoisted_10
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("form", {
                onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.editBoardFunc && _ctx.editBoardFunc(...args)), ["prevent"])),
                class: "d-flex align-content-end"
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_11, "نام جدید بورد " + _toDisplayString(_ctx.activeBoardInfo?.title) + " را وارد کنید", 1),
                  _createVNode(_component_el_input, {
                    type: "text",
                    size: "small",
                    modelValue: _ctx.EditBoardName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.EditBoardName) = $event)),
                    placeholder: "نام بورد"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("button", {
                    ref: "submitEditBoard",
                    disabled: !_ctx.EditBoardName,
                    type: "submit",
                    class: "btn btn-sm btn-primary text-nowrap"
                  }, _hoisted_16, 8, _hoisted_13)
                ])
              ], 32)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_popover, {
          placement: "right",
          width: 300,
          trigger: "click"
        }, {
          reference: _withCtx(() => [
            _hoisted_17
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("form", {
                onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createBoard && _ctx.createBoard(...args)), ["prevent"])),
                class: "d-flex align-content-end"
              }, [
                _createElementVNode("div", null, [
                  _hoisted_18,
                  _createVNode(_component_el_input, {
                    type: "text",
                    size: "small",
                    modelValue: _ctx.BoardName,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.BoardName) = $event)),
                    placeholder: "نام بورد"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("button", {
                    ref: "submitCreateBoard",
                    disabled: !_ctx.BoardName,
                    type: "submit",
                    class: "btn btn-sm btn-primary text-nowrap"
                  }, _hoisted_23, 8, _hoisted_20)
                ])
              ], 32)
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (cat, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            class: _normalizeClass(["col min-w-175px mw-200px min-h-150px m-5 card rounded-2 card-body shadow-sm p-2 border border-2 border-dotted border-gray-400", 
            cat.id === null
              ? 'bg-light-primary border border-2 border-dotted border-primary'
              : ''
          ])
          }, [
            _createElementVNode("span", _hoisted_26, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr079.svg" })
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createVNode(_component_el_input, {
                modelValue: _ctx.categories[i].name,
                "onUpdate:modelValue": ($event: any) => ((_ctx.categories[i].name) = $event),
                size: "small",
                placecategories: "عنوان سربرگ را وارد کنید"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createVNode(_component_el_select, {
                modelValue: _ctx.categories[i].sort,
                "onUpdate:modelValue": ($event: any) => ((_ctx.categories[i].sort) = $event),
                placecategories: "انتخاب موقعیت",
                size: "small"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories.length, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item,
                      label: item,
                      value: item
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue"])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("button", {
                class: "btn btn-sm btn-outline bg-light-primary btn-outline-dashed btn-outline-primary",
                onClick: ($event: any) => (cat.id ? _ctx.update(i) : _ctx.create(i))
              }, _toDisplayString(cat.id ? "ذخیره" : "ایجاد"), 9, _hoisted_32),
              _createVNode(_component_el_popconfirm, {
                "confirm-button-text": _ctx.translate('yes'),
                "icon-color": "#626AEF",
                title: _ctx.translate('Are you sure you want to delete this'),
                onConfirm: ($event: any) => (cat.id ? _ctx.deleteCat(cat.id) : _ctx.remove(i))
              }, {
                reference: _withCtx(() => [
                  _createElementVNode("button", _hoisted_33, _toDisplayString(cat.id ? "حذف" : "پاک کن"), 1)
                ]),
                _: 2
              }, 1032, ["confirm-button-text", "title", "onConfirm"])
            ])
          ], 2))
        }), 128)),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("button", {
            disabled: _ctx.disabledAdd,
            class: "btn btn-icon w-100px h-100px btn-circle btn-light-primary m-auto",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.add && _ctx.add(...args)))
          }, _hoisted_38, 8, _hoisted_35)
        ])
      ])
    ])
  ])), [
    [_directive_loading, _ctx.loadingCategory]
  ])
}